import(/* webpackMode: "eager" */ "/vercel/path0/app/profile/points/page.tsx");
